import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../context/SubscriptionContext';
import './UpgradePromptModal.css';

const UpgradePromptModal = ({ 
  isOpen, 
  onClose, 
  feature,
  title,
  message 
}) => {
  const navigate = useNavigate();
  const { planDisplayName, planName } = useSubscription();

  if (!isOpen) return null;

  const featureLabels = {
    productPostingLimit: 'Product Posting Limit',
    canReceiveRFQs: 'Receive RFQs',
    canViewBuyerContacts: 'View Buyer Contacts',
    canReceiveDirectCalls: 'View Mobile Number',
    'View Mobile Number': 'View Mobile Number',
    buyerDirectoryAccess: 'Buyer Directory Access',
    canUploadVideos: 'Video Upload',
    maxProductImages: 'Product Images',
    canLiveChat: 'Live Chat',
    'Live Chat': 'Live Chat',
    canHighlightBrand: 'Brand Highlight',
    canAddProfessional: 'Professional Profile',
    canSubmitProjects: 'Submit Projects',
    canPostNews: 'Post News',
    trustedBadgeAvailable: 'Trusted Badge'
  };

  const handleUpgrade = () => {
    onClose();
    navigate('/membership-packages');
  };

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        <div className="upgrade-modal-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="30" stroke="#F5A623" strokeWidth="4"/>
            <path d="M32 18V38" stroke="#F5A623" strokeWidth="4" strokeLinecap="round"/>
            <circle cx="32" cy="46" r="3" fill="#F5A623"/>
          </svg>
        </div>

        <h2 className="upgrade-modal-title">
          {title || 'Upgrade Required'}
        </h2>

        <p className="upgrade-modal-message">
          {message || `Your current ${planDisplayName} plan does not include ${featureLabels[feature] || feature}. Upgrade to a higher plan to unlock this feature.`}
        </p>

        <div className="upgrade-modal-current-plan">
          <span>Current Plan:</span>
          <span className="upgrade-modal-plan-name">{planDisplayName}</span>
        </div>

        <div className="upgrade-modal-features">
          <h4>What you'll get with an upgrade:</h4>
          <ul>
            {planName === 'basic' && (
              <>
                <li>✓ Up to 100-200 products</li>
                <li>✓ View buyer contact details</li>
                <li>✓ Upload company videos</li>
                <li>✓ Live chat with buyers</li>
                <li>✓ Brand spotlight feature</li>
                <li>✓ Post news & projects</li>
              </>
            )}
            {planName === 'gcc-business' && (
              <>
                <li>✓ Up to 200 products</li>
                <li>✓ Global buyer contacts (not just GCC)</li>
                <li>✓ Unlimited buyer directory access</li>
                <li>✓ Priority listing</li>
              </>
            )}
          </ul>
        </div>

        <div className="upgrade-modal-actions">
          <button className="upgrade-modal-btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
          <button className="upgrade-modal-btn-primary" onClick={handleUpgrade}>
            View Plans & Upgrade
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePromptModal;
